'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

exports.default = init;

var _helpers = require('./_helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GiftMessage = {
  init: function init(_ref) {
    var el = _ref.el,
        context = _ref.context;

    this.context = context;
    this.els = {
      el: el,
      giftMsgText: context.getElement('.' + context.className + '_Text'),
      giftMsgButton: context.getElement('.' + context.className + '_Button'),
      giftMsgButtonAdd: context.getElement('.' + context.className + '_Add'),
      giftMsgButtonEdit: context.getElement('.' + context.className + '_Edit'),
      giftMsgButtonCancel: context.getElement('.' + context.className + '_Cancel'),
      giftMsgTextarea: context.getElement('.' + context.className + '_Textarea'),
      giftMsgCharacterLimit: context.getElement('.' + context.className + '_CharacterCount'),
      giftMsgSave: context.getElement('.' + context.className + '_ButtonSave'),

      // The input is not within the context
      noteInput: document.querySelector('.' + context.className + '_Input')
    };

    this.initialGiftMsgText = this.els.giftMsgText.innerText;

    this.initialcharacterLimit = parseInt(this.els.giftMsgTextarea.getAttribute('maxlength'));
    this.remainingCharacterLimit = this.initialcharacterLimit;

    this.listeners = (0, _create2.default)(_helpers.Listeners);

    this.methods.copyTextToInput = this.methods.copyTextToInput.bind(this);
    this.methods.emptyInput = this.methods.emptyInput.bind(this);
    this.methods.updateCharacterCount = this.methods.updateCharacterCount.bind(this);

    this.setupListeners();
  },

  setupListeners: function setupListeners() {
    var _this = this;

    this.els.giftMsgButton.addEventListener('click', function (e) {
      var isExpanded = _this.els.el.getAttribute('aria-expanded');

      if (isExpanded === 'true') {
        _this.els.el.setAttribute('aria-expanded', 'false');
        _this.els.giftMsgButtonCancel.setAttribute('aria-hidden', 'true');

        if (_this.els.giftMsgTextarea.value.trim().length) {
          _this.els.giftMsgButtonAdd.setAttribute('aria-hidden', 'true');
          _this.els.giftMsgButtonEdit.setAttribute('aria-hidden', 'false');
        } else {
          _this.els.giftMsgButtonAdd.setAttribute('aria-hidden', 'false');
          _this.els.giftMsgButtonEdit.setAttribute('aria-hidden', 'true');
        }

        // this.methods.emptyInput()
      } else {
        _this.els.el.setAttribute('aria-expanded', 'true');
        _this.els.giftMsgButtonAdd.setAttribute('aria-hidden', 'true');
        _this.els.giftMsgButtonEdit.setAttribute('aria-hidden', 'true');
        _this.els.giftMsgButtonCancel.setAttribute('aria-hidden', 'false');
      }
    });

    // Copy the text as the customer types
    this.els.giftMsgTextarea.addEventListener('input', function (e) {
      _this.methods.copyTextToInput(e.target.value);
    });
    // Copy the text when focus leaves the textarea
    this.els.giftMsgTextarea.addEventListener('blur', function (e) {
      _this.methods.copyTextToInput(e.target.value);
    });

    window.addEventListener('load', function (e) {
      _this.methods.updateCharacterCount(_this.els.giftMsgTextarea.value);
    });

    this.els.giftMsgSave.addEventListener('click', function (e) {
      e.preventDefault();

      var giftMessage = _this.els.giftMsgTextarea.value.trim();

      _this.els.el.setAttribute('aria-expanded', 'false');
      _this.els.giftMsgButtonCancel.setAttribute('aria-hidden', 'true');

      if (giftMessage.length) {
        _this.els.giftMsgButtonAdd.setAttribute('aria-hidden', 'true');
        _this.els.giftMsgButtonEdit.setAttribute('aria-hidden', 'false');
      } else {
        _this.els.giftMsgButtonAdd.setAttribute('aria-hidden', 'false');
        _this.els.giftMsgButtonEdit.setAttribute('aria-hidden', 'true');
      }

      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: (0, _stringify2.default)({
          note: giftMessage
        })
      }).then(function (response) {
        return response.json();
      }).catch(function (error) {
        console.error('Error:', error);
      });
    });
  },


  methods: {
    copyTextToInput: function copyTextToInput(value) {
      this.els.noteInput.value = value;
      this.methods.updateCharacterCount(value);
    },
    emptyInput: function emptyInput() {
      this.els.giftMsgTextarea.innerText = '';
      this.els.giftMsgTextarea.value = '';
      this.els.noteInput.value = '';

      this.methods.updateCharacterCount('');
    },
    updateCharacterCount: function updateCharacterCount(value) {
      value = value.trim();

      if (value.length) {
        this.els.giftMsgText.innerHTML = value + ' - <button type="button" class="crt-GiftMessage_Button crt-GiftMessage_Button-inline" onclick="document.getElementById(\'GiftMessageAdd\').click()">' + this.els.giftMsgButtonEdit.innerText + '</button>';
      } else {
        this.els.giftMsgText.innerText = this.initialGiftMsgText;
      }

      var characterLimitText = this.els.giftMsgCharacterLimit.innerText.toString().trim();

      var charactersRemaining = this.initialcharacterLimit - value.length;

      characterLimitText = characterLimitText.replace(this.remainingCharacterLimit.toString() + ' of ' + this.initialcharacterLimit.toString(), charactersRemaining.toString() + ' of ' + this.initialcharacterLimit.toString());

      if (characterLimitText.length > 0) {
        this.els.giftMsgCharacterLimit.innerText = characterLimitText;
        this.remainingCharacterLimit = charactersRemaining;
      }
    }
  }
};

function init(_ref2) {
  var el = _ref2.el,
      context = _ref2.context;

  var giftMessage = (0, _create2.default)(GiftMessage);
  giftMessage.init({ el: el, context: context });
}